/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {StatusDotComponent} from './status-dot.component';

@NgModule({
    declarations: [StatusDotComponent],
    exports: [StatusDotComponent]
})
export class StatusDotModule {
}
